
const bannerData = [
	{
		image: {
			desktop: "/assets/images/homepage-banner/homepage-banner-01.jpg",
			mobile: "/assets/images/homepage-banner/homepage-banner-01-mobi.jpg",
			alt: "The Standard Bank Tutuwa Community Foundation",
		},
		title: "The Standard Bank Tutuwa Community Foundation",
		description: "A strong education system where every young person thrives and contributes to South Africa’s growth and prosperity.",
		button: {
			target: "_self",
			text: "More about us",
			url: "/about",
			dataIntent: "informational",
			dataScope: "link component",
			dataId: "link_content",
			dataText: "the standard bank tutuwa community foundation | more about us button click"
		},
	}
];

export { bannerData };
